import { makeAutoObservable, runInAction } from 'mobx'
import apiClient from '../utils/apiClient'
import logger from '../utils/logger'

class ShopStore {
  shop = null
  hasShop = false
  isLoading = false
  error = null

  constructor() {
    makeAutoObservable(this)
  }

  // Проверка наличия магазина у текущего пользователя
  async checkShop() {
    runInAction(() => {
      this.isLoading = true
      this.error = null
    })

    try {
      const response = await apiClient.get('/shops/my')
      
      runInAction(() => {
        this.hasShop = response.data.hasShop
        this.shop = response.data.shop || null
        this.isLoading = false
      })

      logger.log('Проверка магазина завершена:', this.hasShop)
      return this.hasShop

    } catch (error) {
      runInAction(() => {
        // Если 404 - значит магазина нет
        if (error.response?.status === 404) {
          this.hasShop = false
          this.shop = null
        } else {
          this.error = error.response?.data?.error || 'Ошибка при проверке магазина'
          logger.error('Ошибка при проверке магазина:', error)
        }
        this.isLoading = false
      })

      return false
    }
  }

  // Создание нового магазина
  async createShop(shopData) {
    runInAction(() => {
      this.isLoading = true
      this.error = null
    })

    try {
      const response = await apiClient.post('/shops', shopData)
      
      runInAction(() => {
        this.shop = response.data.shop
        this.hasShop = true
        this.isLoading = false
      })

      logger.log('Магазин успешно создан:', this.shop)
      return this.shop

    } catch (error) {
      runInAction(() => {
        this.error = error.response?.data?.error || 'Ошибка при создании магазина'
        this.isLoading = false
      })

      logger.error('Ошибка при создании магазина:', error)
      throw error
    }
  }

  // Обновление данных магазина
  async updateShop(updateData) {
    runInAction(() => {
      this.isLoading = true
      this.error = null
    })

    try {
      const response = await apiClient.put('/shops/my', updateData)
      
      runInAction(() => {
        this.shop = response.data.shop
        this.isLoading = false
      })

      logger.log('Данные магазина обновлены:', this.shop)
      return this.shop

    } catch (error) {
      runInAction(() => {
        this.error = error.response?.data?.error || 'Ошибка при обновлении магазина'
        this.isLoading = false
      })

      logger.error('Ошибка при обновлении магазина:', error)
      throw error
    }
  }

  // Очистка ошибок
  clearError() {
    runInAction(() => {
      this.error = null
    })
  }

  // Сброс состояния
  reset() {
    runInAction(() => {
      this.shop = null
      this.hasShop = false
      this.isLoading = false
      this.error = null
    })
  }
}

const shopStore = new ShopStore()
export default shopStore 